import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
// import HubspotForm from 'react-hubspot-form';

import Layout from 'components/Layout';
import Meta from 'components/Meta';
import Image from 'components/Image';
import { ContactContainer } from 'styles/contact';

// import {setUTMToHubspotForm} from '../utils/utmUtil'

const ContactPage = ({ path }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://american-technology40184.activehosted.com/f/embed.php?id=1';
    script.type = 'text/javascript';
    script.charset = 'utf-8';

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return (<>
    <Meta title="We are here to help | Get in Touch With Our Customer Support | ATC"
      description="Reach us for any queries related to Project Management Trainings, Managed Services, Cloud Integration, & Digital Transformation. We provide 24/7 customer support. " />
    <Layout path={path}>
      <ContactContainer>
        <section>
          <div className="contact-hero-main">
            <div className="contact-bg">
              <Image
                src="contact/contact-bg.png"
                alt="globe"
                style={{ position: 'absolute', width: 380 }}
              />
            </div>
            <div className="container">
              <div className="inner-hero-area contact-hero">
                <h1 className="white">
                  Contact
                  <span className="pink"> us.</span>
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="contact-form-main">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                <div className="_form_1"></div>
                  {/* <HubspotForm
                    portalId="2117583"
                    formId="ac0e03f8-0a05-4604-b539-ade7de198e40"
                    submitButtonClass="pink-btn"
                    onFormReady={()=> setUTMToHubspotForm()}
                  /> */}
                </div>
                <div className="col-md-4 offset-md-2">
                  <div className="contact-address-block">
                    <div className="single-address">
                      <h4>Address</h4>
                      <p>12951 University Ave #200, Clive, IA 50325</p>
                    </div>
                    <div className="single-address">
                      <h4>Phone</h4>
                      <a href="tel:515-974-5619">(515) 974-5619</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="our-office-main">
            <div className="container">
              <h2 className="big-heading white-txt">Our Offices.</h2>
              <div className="row">
                <div className="col-md-4">
                  <Image
                    type="background"
                    tag="div"
                    src="contact/contact-bg-1.png"
                    className="offices-single"
                  >
                    <div className="offices-overlay">
                      <h4>Clive, Iowa</h4>
                      <p>12951 University Ave #200, Clive, IA 50325</p>
                    </div>
                  </Image>
                </div>
                <div className="col-md-4">
                  <Image
                    type="background"
                    tag="div"
                    src="contact/contact-bg-2.png"
                    className="offices-single"
                  >
                    <div className="offices-overlay">
                      <h4>Chennai, India</h4>
                      <p>
                        D3/4, 3rd Floor, Phase 2, IITM Research Park, Tharamani,
                        Chennai-600116
                      </p>
                    </div>
                  </Image>
                </div>
                <div className="col-md-4">
                  <Image
                    type="background"
                    tag="div"
                    src="contact/contact-bg-3.png"
                    className="offices-single"
                  >
                    <div className="offices-overlay">
                      <h4>Pune, India</h4>
                      <p>
                        Ground floor, Gate Number 301/2, Adisa Icon, Mumbai
                        Banglore Highway, Bavdhan, Pune, Maharashtra 411021
                      </p>
                    </div>
                  </Image>
                </div>
              </div>
            </div>
          </div>
        </section>
      </ContactContainer>
    </Layout>
  </>)
};

ContactPage.propTypes = {
  path: PropTypes.string.isRequired,
};

export default ContactPage;
